import { useMeasure } from 'react-use';
import ScrollLineItem from '../ScrollLineItem/ScrollLineItem';
import { ScrollItem, Wrapper } from './ScrollLine.style';

export type ScrollLineProps = {
  baseImageUrl: string;
  items: any[];
  item: any;
  onClick: (item: any) => void;
};

export function ScrollLine(props: ScrollLineProps) {
  const { baseImageUrl, items } = props;
  const [ref, { height }] = useMeasure();

  function renderItem(item: Json, index: number) {
    const isSelected = item.id === props.item.id;

    return (
      <ScrollItem key={index + item.id}>
        <ScrollLineItem
          onClick={props.onClick}
          baseImageUrl={baseImageUrl}
          key={item.id}
          item={item}
          isSelected={isSelected}
        />
      </ScrollItem>
    );
  }

  function renderItems() {
    return items.map((item: Json, index) => renderItem(item, index));
  }

  return (
    <Wrapper ref={ref} className='ScrollLine-wrapper' data-testid='ScrollLine-wrapper'>
      {renderItems()}
    </Wrapper>
  );
}

export default ScrollLine;
